import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import TripleLevel from "./TripleLevel";

export default function MultiLevel({ item }) {
  // Local State
  const [open, setOpen] = useState(false);

  // Redux State
  const leftBarStatus = useSelector((state) => state.leftBar.leftBarStatus);

  useEffect(() => {
    if (!leftBarStatus) {
      setOpen(false);
    }
  }, [leftBarStatus]);

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  return (
    <>
      <ListItem button onClick={handleClick}>
        <ListItemIcon style={{ color: "#b0b0b0" }}>{item.icon}</ListItemIcon>
        <ListItemText primary={item.title} sx={{ marginLeft: "-5px" }} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {item.items.map((child, key) => (
            <>
              {typeof child.items !== "undefined" ? (
                <TripleLevel child={child} />
              ) : (
                <Link
                  to={child.path}
                  key={key}
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <ListItem
                    button
                    style={{
                      background:
                        window.location.pathname === child.path
                          ? "#36B057"
                          : "none",
                    }}
                  >
                    <ListItemIcon style={{ color: "white" }}>
                      {child.icon}
                    </ListItemIcon>
                    <ListItemText primary={child.title} />
                  </ListItem>
                </Link>
              )}
            </>
          ))}
        </List>
      </Collapse>
    </>
  );
}

MultiLevel.propTypes = {
  item: PropTypes.object,
};
